import { Box, Grid, Typography } from "@material-ui/core"
import classNames from "classnames"
import { useStyles } from "./roadmap-backlog-sistemas-styles"
import { isTouchDevice } from "utils/is-touchone-device"
import { memo, useCallback, useEffect } from "react"
import { ButtonOptions } from "./components/button-options/button-options"
import { SistemasRoadmapMock } from "data/mocks/sistemas-roadmap-mock"

export interface RoadmapBacklogSistemasProps {
    carregando: boolean
    setSistemaSelected: React.Dispatch<React.SetStateAction<string>>
    sistemaSelected: string
    isEmVotacao: boolean
}

const RoadmapBacklogSistemasComp = ({ carregando, setSistemaSelected, sistemaSelected }: RoadmapBacklogSistemasProps) => {

    const classes = useStyles()

    const validSistemaSelected = useCallback(() => {
        setSistemaSelected(prev => {
            if (!prev) {
                if (SistemasRoadmapMock.length > 0) {
                    return SistemasRoadmapMock[0].Key;
                }
                return "";
            }
            return prev;
        })
    }, [setSistemaSelected])

    const selecionarSistema = (sistema: string) => {
        setSistemaSelected(sistema)
    }

    useEffect(() => {
        validSistemaSelected()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const sistemas = SistemasRoadmapMock

    return (
        <Box className={classes.container}>
            <Grid container spacing={1}>
                <Grid container spacing={1} className={classNames(classes.sistemas, carregando && sistemas.length === 0 && classes.gap, isTouchDevice() && classes.hiddenScroll)}>
                    {!carregando && sistemas.length === 0 && (
                        <Grid item xs={12}>
                            <Typography variant="body1" align="center">
                                Nenhum Sistema Encontrado
                            </Typography>
                        </Grid>
                    )}
                    {(!carregando || sistemas.length > 0) &&
                        sistemas
                            .sort((a, b) => a.Key.localeCompare(b.Key))
                            .map((sistema) => (
                                <Grid
                                    key={sistema.Key}
                                    item
                                    xs="auto"
                                >
                                    <ButtonOptions
                                        isSistema
                                        option={sistema}
                                        setSelected={selecionarSistema}
                                        selected={sistema.Key === sistemaSelected}
                                    />
                                </Grid>
                            ))}
                </Grid>
            </Grid>
        </Box>
    )
}

export const RoadmapBacklogSistemas = memo(RoadmapBacklogSistemasComp)

RoadmapBacklogSistemas.displayName = 'RoadmapBacklogSistemas'